export const WIDGETS_SEARCH_QUERY_PARAM_NAMES = {
  WIDGET_TYPE: "widget",
  CAMPAIGN_ID: "campaign_id",
  ACCOUNT_ID: "account_id",
  CONTACT_ID: "contact_id",
  PHONE: "phone",
  EMAIL: "email",

  DIALER_TOUR_CALL_STATUS: "call_status",
} as const;
